import React from "react";
import { InformationCircleIcon } from "@heroicons/react/24/outline";

/**
 * Shown in place of the price breakdown and price editing when an order is never
 * billed. Such an order is a leg of a split order: the customer pays for the work on
 * the original order, so this order's price is $0 and editing it would do nothing.
 */
export function NotBillablePanel() {
  return (
    <div className="flex flex-col items-center px-4 py-6 text-center">
      <InformationCircleIcon className="mb-2 h-8 w-8 text-gray-400 dark:text-gray-500" />
      <p className="text-sm font-semibold text-gray-700 dark:text-gray-100">
        This order is not billed
      </p>
      <p className="mt-1 text-xs text-gray-600 dark:text-gray-400">
        It is a leg of a split order. The customer pays for this work on the
        original order, so it never goes on an invoice and its price is $0.
      </p>
    </div>
  );
}
